import { render, staticRenderFns } from "./taskCenter.vue?vue&type=template&id=6efcbff5&"
import script from "./taskCenter.vue?vue&type=script&lang=js&"
export * from "./taskCenter.vue?vue&type=script&lang=js&"
import style0 from "./taskCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports